<template>
  <div class="bottom">
    <div class="navBtns">
      <a :class="{ currentNav: currentIndex == 1 }" @click="handleChangeNav(1)">
        <div>
          <img :src="currentIndex == 1 ? home2 : home1" />
        </div>
        首页
      </a>
      <a :class="{ currentNav: currentIndex == 2 }" @click="handleChangeNav(2)">
        <div>
          <img :src="currentIndex == 2 ? classify2 : classify1" />
        </div>
        分类
      </a>
      <a :class="{ currentNav: currentIndex == 3 }" @click="handleChangeNav(3)">
        <div>
          <img :src="currentIndex == 3 ? my2 : my1" />
        </div>
        我的
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ipFlag: false,

      currentIndex: 1,
      home1: require("../../assets/images/icon-shouye01.png"),
      home2: require("../../assets/images/icon-shouye02.png"),
      classify1: require("../../assets/images/icon-fenglei01.png"),
      classify2: require("../../assets/images/icon-fenglei02.png"),
      my1: require("../../assets/images/icon-wode01.png"),
      my2: require("../../assets/images/icon-wode02.png")
    };
  },
  watch: {
    $route: {
      handler(val) {
        if (val.name == "home") {
          this.currentIndex = 1;
        } else if (val.name == "classify") {
          this.currentIndex = 2;
        } else if (val.name == "mine") {
          this.currentIndex = 3;
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    handleChangeNav(index) {
      if (localStorage.getItem("isIpUser") && index == 3) {
        this.$dialog
          .confirm({
            title: "提示",
            message: "IP用户不支持查看，是否切换账号密码登录?"
          })
          .then(() => {
            this.$router.push({ path: "/login" });
          })
          .catch(() => {});
        return;
      }

      this.currentIndex = index;
      if (this.currentIndex == 1) {
        this.$router.push({ path: "home" });
      }
      if (this.currentIndex == 2) {
        this.$router.push({ path: "classify" });
      }
      if (this.currentIndex == 3) {
        this.$router.push({ path: "mine" });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom {
  position: fixed;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 53.5px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  padding-top: 13px;
  a {
    font-size: 10px;
  }
  .currentNav {
    color: #659ded;
  }
  .navBtns {
    display: flex;
    a {
      text-align: center;
      flex: 1;
    }
    img {
      height: 18px;
      margin-bottom: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicBottom/index.vue